import "./Title.css";

const Title = () => {
  return (
    <div>
      <h1 className="title">
        <span />
        <span />
        <span />
        <span />
        Quote Quiz!
      </h1>
    </div>
  );
};

export default Title;
